const ENTRY_MODE_KEY = 'jatt_entry_mode';

export type EntryMode = 'allocation' | 'incremental';

export const getPreferredEntryMode = (): EntryMode => {
  try {
    const saved = localStorage.getItem(ENTRY_MODE_KEY);
    if (saved === 'allocation' || saved === 'incremental') {
      return saved;
    }
  } catch {
    // Ignore localStorage errors
  }

  try {
    if (typeof document !== 'undefined' && document.cookie) {
      const match = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${ENTRY_MODE_KEY}=`));
      if (match) {
        const val = match.split('=')[1];
        if (val === 'allocation' || val === 'incremental') {
          return val;
        }
      }
    }
  } catch {
    // Ignore cookie errors
  }

  return 'incremental';
};

export const savePreferredEntryMode = (mode: EntryMode): void => {
  try {
    localStorage.setItem(ENTRY_MODE_KEY, mode);
  } catch {
    // Ignore localStorage errors
  }

  try {
    if (typeof document !== 'undefined') {
      document.cookie = `${ENTRY_MODE_KEY}=${mode}; path=/; max-age=31536000; SameSite=Lax`;
    }
  } catch {
    // Ignore cookie errors
  }
};

export const RECENT_LOCATIONS_KEY = 'jatt_recent_locations';

export const getRecentLocationIds = (): string[] => {
  try {
    const saved = localStorage.getItem(RECENT_LOCATIONS_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed)) {
        return parsed.filter((id): id is string => typeof id === 'string' && id.trim().length > 0);
      }
    }
  } catch {
    // Ignore localStorage errors
  }
  return [];
};

export const addRecentLocationId = (locationId: string, maxItems = 4): string[] => {
  if (!locationId || typeof locationId !== 'string') return getRecentLocationIds();
  try {
    const current = getRecentLocationIds();
    const updated = [locationId, ...current.filter(id => id !== locationId)].slice(0, maxItems);
    localStorage.setItem(RECENT_LOCATIONS_KEY, JSON.stringify(updated));
    return updated;
  } catch {
    // Ignore localStorage errors
    return [];
  }
};

export const clearRecentLocations = (): void => {
  try {
    localStorage.removeItem(RECENT_LOCATIONS_KEY);
  } catch {
    // Ignore localStorage errors
  }
};

export const NOTIF_LAST_VIEWED_KEY = 'jatt_notif_last_viewed';

export const getNotificationLastViewed = (userId?: string): string | null => {
  const targetKey = userId ? `${NOTIF_LAST_VIEWED_KEY}_${userId}` : NOTIF_LAST_VIEWED_KEY;
  try {
    const val = localStorage.getItem(targetKey) || (!userId ? null : localStorage.getItem(NOTIF_LAST_VIEWED_KEY));
    if (val && !isNaN(new Date(val).getTime())) {
      return val;
    }
  } catch {
    // Ignore localStorage errors
  }

  return null;
};

export const saveNotificationLastViewed = (timestamp: string, userId?: string): void => {
  const targetKey = userId ? `${NOTIF_LAST_VIEWED_KEY}_${userId}` : NOTIF_LAST_VIEWED_KEY;
  try {
    localStorage.setItem(targetKey, timestamp);
  } catch {
    // Ignore localStorage errors
  }
};

export const clearNotificationLastViewed = (userId?: string): void => {
  const targetKey = userId ? `${NOTIF_LAST_VIEWED_KEY}_${userId}` : NOTIF_LAST_VIEWED_KEY;
  try {
    localStorage.removeItem(targetKey);
    if (userId) {
      localStorage.removeItem(NOTIF_LAST_VIEWED_KEY);
    }
  } catch {
    // Ignore localStorage errors
  }
};

export const SUPERVISOR_SELECTED_USER_KEY = 'jatt_supervisor_selected_user';
export const SUPERVISOR_SELECTED_MONTH_KEY = 'jatt_supervisor_selected_month';

export const getSupervisorSelectedUserId = (): string | null => {
  try {
    return sessionStorage.getItem(SUPERVISOR_SELECTED_USER_KEY);
  } catch {
    return null;
  }
};

export const saveSupervisorSelectedUserId = (userId: string | null): void => {
  try {
    if (userId) {
      sessionStorage.setItem(SUPERVISOR_SELECTED_USER_KEY, userId);
    } else {
      sessionStorage.removeItem(SUPERVISOR_SELECTED_USER_KEY);
    }
  } catch {
    // Ignore sessionStorage errors
  }
};

export const getSupervisorSelectedMonth = (): string | null => {
  try {
    return sessionStorage.getItem(SUPERVISOR_SELECTED_MONTH_KEY);
  } catch {
    return null;
  }
};

export const saveSupervisorSelectedMonth = (month: string | null): void => {
  try {
    if (month) {
      sessionStorage.setItem(SUPERVISOR_SELECTED_MONTH_KEY, month);
    } else {
      sessionStorage.removeItem(SUPERVISOR_SELECTED_MONTH_KEY);
    }
  } catch {
    // Ignore sessionStorage errors
  }
};



